export default "__VITE_ASSET__690f5eb7__"